/** @format */
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';

import { DataLayerEventType } from '@toucan/client/global/analytics';
import { MarketContext } from '@toucan/client/global/market';
import { UserContext } from '@toucan/client/global/user';

import { logout } from '@toucan/client/core/user';

import { trackEventsViaDataLayer } from '@toucan/client/shared/helpers/analytics';
import { resetIntercomSession } from '@toucan/client/shared/helpers/intercom';

export const useLogoutAndRedirect = () => {
    const { activeMarket } = useContext(MarketContext);
    const { user } = useContext(UserContext);
    const { t } = useTranslation();

    return async (pathname?: string) => {
        resetIntercomSession();

        await logout();

        const dataLayerEvents = [
            {
                event: DataLayerEventType.USER_LOADED,
                userId: null,
                loginStatus: false,
            },
            {
                event: DataLayerEventType.LOGOUT,
                userId: user?.customerId,
            },
        ];

        trackEventsViaDataLayer(dataLayerEvents);

        // NOTE: Deliberately don't use next/router here so that
        // we force a full page load, refreshing the page memory
        // and ensuring we start from a clean slate
        window.location.pathname =
            pathname ?? `/${activeMarket.slug}/${t('login', { ns: 'urls' })}`;
    };
};
